import React, { MouseEventHandler, useRef } from 'react';
import { isIOS } from 'react-device-detect';
import { DetailWidgetInteractionItem } from '../WidgetElement';
import { sendInteractGATrackEventData } from '../../../../util/gAUtil';
import { getDropShadowStyle } from '../util';
import { useWidgetAnimation } from '../../../Player/hooks/useWidgetAnimation';

const Image = ({
	id,
	style,
	data,
	clickable,
	isHover,
	scenarioId,
	sceneId,
	isShowWidget,
	isExiting,
	onClick,
	handleMouseEnter,
	handleMouseLeave,
	onExitDone,
	exitTiming,
}: DetailWidgetInteractionItem) => {
	const {
		coordinate: { x, y },
		dimension: { w = 150, h = 100 },
		rotation,
	} = style;

	const {
		settings: { imgUrl, bgImgUrl },
		name,
		type,
	} = data;

	const gElementRef = useRef<SVGGElement | null>();
	useWidgetAnimation({ gElementRef, style, isShowWidget, isExiting, onExitDone, exitTiming });

	const handleWidgetAction = (event: React.TouchEvent | React.MouseEvent | React.KeyboardEvent) => {
		event.stopPropagation();
		sendInteractGATrackEventData(type, name, scenarioId, sceneId);
		onClick(event);
	};

	const handleTouchStart = (event: React.TouchEvent) => {
		event.preventDefault();
		handleWidgetAction(event);
	};

	const handleOnKeyDown = (event: React.KeyboardEvent) => {
		if (event.key === 'Enter' || event.key === ' ') {
			handleWidgetAction(event);
		}
	}

	const { dropShadow, hoverDropShadow } = getDropShadowStyle(style.transformSettings);
	const imageSource = isHover ? bgImgUrl || imgUrl : imgUrl;

	return (<g style={{ transform: `rotate(${rotation ?? 0}deg)` }} >
		<g key={id}
			id={id}
			onClick={handleWidgetAction}
			onTouchStart={isIOS ? handleTouchStart : undefined}
			onMouseEnter={handleMouseEnter as MouseEventHandler<SVGGElement>}
			onMouseLeave={handleMouseLeave as MouseEventHandler<SVGGElement>}
			onKeyDown={handleOnKeyDown}
			tabIndex={0}
			role='button'
			aria-label={name}
			ref={r => gElementRef.current = r}
		>
			<foreignObject
				x={x}
				y={y}
				width={w}
				height={h}
				style={{
					display: 'block',
					filter: "drop-shadow(" + (isHover ? (hoverDropShadow || dropShadow) : dropShadow) + ")",
					cursor: clickable ? 'pointer' : 'default',
				}}
				aria-hidden="true"
			>
				<div
					aria-hidden="true"
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						height: '100%',
						cursor: clickable ? 'pointer' : 'default',
					}}
				>
					<img
						alt={name}
						aria-hidden="true"
						className="widget image-widget"
						src={imageSource}
						style={{
							display: 'block',
							width: '100%',
						}}
					/>
				</div>
			</foreignObject>
		</g>
	</g>);
};

export default Image;
